(ns dre.modals.my-searches.tags.views
  (:require
   [clojure.string :as str]
   [dre.app.events :as app-events]
   [dre.components.inputs :refer [checkbox input-text input-textarea]]
   [dre.components.form :refer [form form-item]]
   [dre.i18n.views :refer [tr]]
   [dre.modals.my-searches.tags.events :as events]
   [dre.modals.modal-window :refer [modal-window]]
   [dre.pages.my-searches.tags.utils :refer [tag-pill]]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn color-picker [selected-color]
  [:div
   (doall
    (for [color ["#b60205" "#d93f0b" "#fbca04" "#0e8a16" "#006b75" "#1d76db" "#0052cc" "#5319e7"
                 "#e99695" "#f9d0c4" "#fef2c0" "#c2e0c6" "#bfdadc" "#c5def5" "#bfd4f2" "#d4c5f9"]]
      ^{:key color}
      [:div
       {:style (cond->
                {:display "inline-block"
                 :height "25px"
                 :width "25px"
                 :background-color color
                 :border-radius "6px"
                 :border "1px solid gray"
                 :margin-top "3px"
                 :margin-right "3px"}
                 (= selected-color color)
                 (assoc :border "1px solid black"))
        :on-click #(rf/dispatch [::events/update-data-edit [:color] color])}]))])

(defn- edit-content
  []
  (let [component-name :edit-tags
        data @(rf/subscribe [::events/data-edit])
        user @(rf/subscribe [::app-events/user])]
    [:div
     {:class [component-name]
      :style {:width "100%"}}
     [form
      {:layout "vertical"}
      [:<>
       [form-item
        {:label [tr "Preview"]}
        [:div
         [tag-pill data user]]]
       [form-item
        {:label [tr "Name"]}
        [input-text
         {:on-change #(rf/dispatch [::events/update-data-edit [:name] (-> % .-target .-value)])
          :value (:name data)}]]
       [form-item
        {:label [tr "Description (Optional)"]}
        [input-textarea
         {:on-change #(rf/dispatch [::events/update-data-edit [:description] (-> % .-target .-value)])
          :value (:description data)}]]
       [form-item
        {:label [tr "Color"]}
        [color-picker (:color data)]]]]]))

(defn edit-view
  []
 (let [data @(rf/subscribe [::events/data-edit])
       uuid (:tag_uuid data)
       new? (not uuid)]
  [modal-window
   {:title (if new? "Create new tag" "Edit tag")
    :content edit-content
    :submit? true
    :on-submit #(rf/dispatch [::events/edit data])
    :submit-disabled? (empty? (get data :name ""))
    :submit-text (if new? [tr "Create"] [tr "Edit"])}]))


(defn- copy-content
  []
  (let [component-name :copy-tags
        data @(rf/subscribe [::events/data-copy])
        user @(rf/subscribe [::app-events/user])]
    [:div
     {:class [component-name]
      :style {:width "100%"}}
     [form
      {}
      [form-item
       {:label (r/as-element [:<> [tr "Copy "]
                              [tag-pill data user]
                              [tr " to a new tag"]])}
       [input-text
        {:on-change #(rf/dispatch [::events/update-data-copy [:copy-name] (-> % .-target .-value)])
         :value (:copy-name data)}]]]]))


(defn copy-view
  []
  [modal-window
   {:title "Copy tag"
    :content copy-content
    :submit? true
    :on-submit #(rf/dispatch [::events/copy  @(rf/subscribe [::events/data-copy])])
    :submit-disabled? (empty? (get @(rf/subscribe [::events/data-copy]) :copy-name ""))
    :submit-text [tr "Copy"]}])

(defn- delete-content
  []
  (let [data @(rf/subscribe [::events/data-delete])]
    [:div
     [:div
      [tr "You are about to delete the tags with names: "]
      (str/join ", " (map :title data))
      "."]
     [:div
      [tr "Do you want to proceed?"]]]))

(defn confirm-delete-view
  []
  [modal-window
   {:title "Confirm Delete"
    :content delete-content
    :delete? true
    :on-delete #(rf/dispatch [::events/delete (mapv :uuid  @(rf/subscribe [::events/data-delete]))])}])
